import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { OnboardingFacade } from 'app/main/pages/customer-onboard-flow/store/onboarding/onboarding.facade';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomerOnboardFlowService } from 'app/main/pages/customer-onboard-flow/customer-onboard-flow.service';

import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-onboarding-tell-us-about-you',
  templateUrl: './onboarding-tell-us-about-you.component.html',
  styleUrls: ['./onboarding-tell-us-about-you.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslocoModule]
})
export class OnboardingTellUsAboutYouComponent implements OnInit, OnDestroy {
  @Input() tellUsAboutYouForm!: FormGroup;
  @Output() workTypeSelected = new EventEmitter<void>();

  workTypeList: any[] = [];

  private _unsubscribeAll: Subject<void> = new Subject();

  constructor(
    private _onboardingFacade: OnboardingFacade,
    private _customerOnboardFlowService: CustomerOnboardFlowService
  ) {
    this.workTypeList = this._customerOnboardFlowService.fetchWorkTypeList();
  }

  ngOnInit(): void {
    // Subscribe to store to patch form value if it changes from another source
    this._onboardingFacade.tellUsAboutYouWorkType$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(value => this.tellUsAboutYouForm.get('workType').patchValue(value, { emitEvent: false }));
  }

  onWorkTypeSelect(workType: string): void {
    this.tellUsAboutYouForm.get('workType').setValue(workType);
    this._onboardingFacade.updateTellUsAboutYouWorkType(workType);
    this.workTypeSelected.emit();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}